// client/src/components/Achievements/QuestItem.jsx
import React from "react";

const QuestItem = React.memo(function QuestItem({ quest, color, onClaim, claiming }) {
  const uiStatus =
    quest.status === "progress" && Math.round(Number(quest.percentage || 0)) === 0
      ? "locked"
      : quest.status;

  const title = quest.title || quest.id;
  const desc = quest.description || "";
  const progressText = `${Number(quest.progress || 0)}/${Number(quest.target || 0)}`;
  const percentage = `${Math.round(Number(quest.percentage || 0))}%`;
  const xp = `+${Number(quest.xpReward || 0)} XP`;

  const colors = {
    green: {
      bg: "bg-green-100",
      text: "text-green-600",
      bar: "bg-green-500",
      hover: "hover:border-green-200",
      container: "bg-green-50 border-green-100 opacity-60",
    },
    indigo: {
      bg: "bg-indigo-50",
      text: "text-indigo-600",
      bar: "bg-indigo-500",
      hover: "hover:border-indigo-200",
      container: "bg-indigo-50 border-indigo-100 opacity-60",
    },
    purple: {
      bg: "bg-purple-50",
      text: "text-purple-600",
      bar: "bg-purple-500",
      hover: "hover:border-purple-200",
      container: "bg-purple-50 border-purple-100 opacity-60",
    },
    orange: {
      bg: "bg-orange-50",
      text: "text-orange-600",
      bar: "bg-orange-500",
      hover: "hover:border-orange-200",
      container: "bg-orange-50 border-orange-100 opacity-60",
    },
  };

  const theme = colors[color] || colors.indigo;

  if (uiStatus === "completed") {
    return (
      <div className={`flex items-center gap-4 p-4 rounded-xl border ${theme.container}`}>
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${theme.bg} ${theme.text}`}>
          <i className="fa-solid fa-check"></i>
        </div>

        <div className="flex-1">
          <h4 className="text-sm font-bold text-gray-800 line-through">{title}</h4>
          <p className="text-xs text-gray-500">{desc}</p>
        </div>

        <div className="text-right">
          <span className="text-xs font-bold text-green-600">{xp}</span>
        </div>
      </div>
    );
  }

  const claimable = uiStatus === "claimable";
  const disabled = !claimable || claiming;

  return (
    <div
      className={`flex items-center gap-4 p-4 rounded-xl bg-white border border-gray-100 transition-colors shadow-sm group ${theme.hover}`}
    >
      <div
        className={`w-10 h-10 rounded-lg flex items-center justify-center ${theme.bg} ${theme.text} group-hover:scale-110 transition-transform`}
      >
        <i className="fa-solid fa-scroll"></i>
      </div>

      <div className="flex-1">
        <div className="flex justify-between mb-1">
          <h4 className="text-sm font-bold text-gray-800">{title}</h4>
          <span className="text-xs text-gray-500 font-bold">{progressText}</span>
        </div>

        <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden">
          <div className={`h-full rounded-full ${theme.bar}`} style={{ width: percentage }}></div>
        </div>

        <p className="text-xs text-gray-400 mt-1">{desc}</p>
      </div>

      <button
        onClick={() => claimable && onClaim(quest.id)}
        disabled={disabled}
        className={`px-3 py-1.5 rounded-lg text-xs font-bold transition ${
          claimable ? "bg-green-600 text-white hover:bg-green-700" : "bg-gray-100 text-gray-400 cursor-not-allowed"
        }`}
      >
        {claiming ? "Claiming..." : "Claim"}
      </button>
    </div>
  );
});

export default QuestItem;
